import { useTheme } from '@emotion/react';

export function ButtonOrderingCatalog({ isActive, callback, children }) {
  const theme = useTheme();
  return (
    <button
      css={{
        color: isActive ? theme.colors.text : '#ccc',
        fontWeight: isActive ? 700 : 400,
        fontFamily: 'Golos',
        cursor: 'pointer',
        ':hover': {
          fontFamily: 'Montserrat',
          fontWeight: 700,
          color: theme.colors.text,
        },
      }}
      onClick={callback}
      type='button'
    >
      {children}
    </button>
  );
}

export function ButtonFilterCatalog({ isActive, callback, children }) {
  const theme = useTheme();
  return (
    <button
      css={{
        padding: 10,
        lineHeight: '5px',
        background: isActive ? '#f44336' : 'none',
        borderRadius: 3,
        color: isActive ? theme.colors.white : '#333',
        transition: 'all 0.2s ease, box-shadow 0.4s ease',
        cursor: 'pointer',
      }}
      type='button'
      onClick={callback}
    >
      {children}
    </button>
  );
}

export function ButtonFilterPersons({ callback, children }) {
  return (
    <button
      css={{
        width: 220,
        background: '#ff4a2e',
        backgroundImage: 'linear-gradient(120deg, #ff4a2e 0%, #de2839 100%)',
        boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.25)',
        padding: '9px 25px',
        fontSize: 12,
        fontWeight: 500,
        borderRadius: 24,
        backgroundSize: '500% 500%',
        color: '#fff',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
      }}
      type='button'
      onClick={callback}
    >
      {children}
    </button>
  );
}

export function ButtonShowMore({ callback, loadingText = '' }) {
  return (
    <button
      onClick={() => {
        callback();
      }}
      type='button'
      css={{
        width: '100%',
        background: '#dfdfdf',
        height: 45,
        borderRadius: 4,
        padding: '0 0.8em',
        fontSize: '1rem',
        fontFamily: 'Golos',
        fontWeight: 500,
        whiteSpace: 'normal',
        border: '2px solid #dfdfdf',
        cursor: 'pointer',
        textDecoration: 'none',
        color: '#000',
        lineHeight: '41px',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'all 0.2s ease',
        ':hover': {
          background: 'inherit',
        },
      }}
    >
      {loadingText || 'Показать больше'}
    </button>
  );
}
